import { getPublicEnv } from '@tucan/utils'

export const isQACompatibleFile = (file: { type?: string; name: string }): boolean => {
  return String(getPublicEnv('SUPPORTED_QUANTITATIVE_ANALYTICS_FILE_TYPES')).toLowerCase().split(',')
    .some(check => {
      if (check.startsWith('.')) {
        return file.name.toLowerCase().endsWith(check)
      }

      if (!file.type) {
        return false
      }

      return new RegExp(check.replace('*', '.*'), 'i').test(file.type)
    })
}
